<template>
  <div>
    <div class="logo-wrapper">
      <img class="bg-img" :src="`${pre}hero/bg-strip.png`" alt="" />
    </div>
    <div class="navbar">
      <div style="z-index: 10; position: absolute; right: 20px; top: 30px">
        <img class="legal" :src="`${pre}hero/DRINKAWARE.png`" width="200" />
      </div>
      <img class="navbar__img" :src="`${pre}hero/CM_logo.png`" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  }, 
  pre: {
    type: String,
    default: "1",
  }
});
$(document).ready(function () {});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.navbar {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  position: relative;
}
.bg-img {
  position: absolute;
  left: 0;
  width: 100%;
  height: 135px;
  z-index: 1;
}
.navbar__img {
  z-index: 2;
}
.navbar__img {
  display: block;
  position: absolute;
  left: 30px;
  top: 10px;
  padding: 15px 0px;
  width: 200px;
}
@media (max-width: 650px) {
  .navbar__img {
    left: 25% !important;
    z-index: 2;
    width: 200px;
  }
  .navbar__img {
    display: block;
    position: initial;
    margin-bottom: -120px;
  }
  .bg-img, .navbar {
    z-index: 10;
  }
  .legal {
    z-index: 10;
    position: absolute;
    right: -20px;
    top: 0px;
  }
}
@media (max-width: 390px) {
  .bg-img {
    height: 120px !important;
  }
  .navbar__img {
    margin-bottom: -90px !important;
  }
}
@media (max-width: 375px) {
  .bg-img {
    height: 90px !important;
  }
  .navbar__img {
    margin-bottom: -30px !important;
  }
  img.navbar__img {
    margin-bottom: -60px !important;
    width: 120px !important;
  }
}

</style>
